<div class="settlement-page" [class.mobile-view]="isMobileView">

  <div class="settlement-toolbar">
    <mat-form-field appearance="outline" class="toolbar-field">
      <mat-label>Filter by amount ($)</mat-label>
      <input id="searchBox" matInput type="number" (input)="onSearch($event)" placeholder="e.g. 100.00" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div class="toolbar-option">
      <mat-checkbox
        [checked]="includeUnsoldSeats"
        (change)="onIncludeUnsoldSeatsChange($event.checked)">
        Include webinars with unsold seats
      </mat-checkbox>
    </div>

    <div class="toolbar-option">
      <mat-checkbox
        [checked]="includePendingShipping"
        (change)="onIncludePendingShippingChange($event.checked)">
        Include webinars with pending shipping
      </mat-checkbox>
    </div>

    <button
      class="settlement-action"
      *ngIf="toBeSettledDetails.length > 0"
      (click)="onSettleWebinar()">
      Settle {{ toBeSettledDetails.length }} Selected ({{ getSelectedTotal() | number:'1.2-2' }}$)
    </button>
  </div>

  <div class="empty-state" *ngIf="!hasVisibleRooms()">
    <mat-icon>inbox</mat-icon>
    <h3>No webinars to display</h3>
    <p *ngIf="!includeUnsoldSeats && !includePendingShipping">
      By default, only fully sold webinars with completed USPS shipping are shown.
    </p>
    <p *ngIf="includeUnsoldSeats || includePendingShipping">
      No settlement data found for the current filters.
    </p>
  </div>

  <mat-accordion class="settlement-accordion" multi>
    <mat-expansion-panel
      class="room-panel"
      *ngFor="let detail of details"
      [hidden]="getFilteredDetails(detail).length === 0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="room-header">
            <span class="room-name">{{ detail.roomName }}</span>
            <div class="room-summary">
              <span class="summary-chip pending">
                Pending <strong>${{ detail.pendingForSettlement | number:'1.2-2' }}</strong>
              </span>
              <span class="summary-chip ready">
                Ready <strong>${{ detail.readyForSettlement | number:'1.2-2' }}</strong>
              </span>
              <span class="summary-chip ready-net" *ngIf="detail.readyForSettlement > 0">
                Net Ready <strong>${{ detail.readyNetSettlement | number:'1.2-2' }}</strong>
              </span>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="webinar-grid">
        <div
          class="webinar-card"
          *ngFor="let settlement of getFilteredDetails(detail)"
          [class.selected]="isSelected(settlement)"
          [class.not-settleable]="!settlement.isWebinarSettlementAllowed">

            <div class="card-top">
            <div class="card-select">
            <mat-checkbox
              [checked]="isSelected(settlement)"
              (change)="onChangeSelection($event, settlement, detail.roomOwnerId)"
              [disabled]="!settlement.isWebinarSettlementAllowed"
              [ngClass]="{ 'disabled-checkbox': !settlement.isWebinarSettlementAllowed }">
            </mat-checkbox>
            <p
              class="disabled-reason"
              *ngIf="!settlement.isWebinarSettlementAllowed && settlement.settlementDisabledReason">
              <mat-icon>info_outline</mat-icon>
              {{ settlement.settlementDisabledReason }}
            </p>
            </div>

            <div class="card-title-wrap">
              <h4 class="card-title">{{ settlement.webinarName }}</h4>
              <div class="card-badges">
                <span class="status-badge ready" *ngIf="settlement.isWebinarSettlementAllowed">Ready to settle</span>
                <span class="status-badge sold-out" *ngIf="settlement.allSeatsSold">All seats sold</span>
                <span class="status-badge ready" *ngIf="settlement.isShippingCompleted">Shipping complete</span>
                <span class="status-badge pending" *ngIf="!settlement.isShippingCompleted">Shipping pending</span>
                <span class="status-badge unsold" *ngIf="!settlement.allSeatsSold">{{ settlement.seatsRemainingToBeSold }} seats left</span>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Webinar Status</span>
                <span class="info-value status-text" [ngClass]="getWebinarStatusClass(settlement.webinarStatus)">
                  {{ settlement.webinarStatus }}
                </span>
              </div>
              <div class="info-item">
                <span class="info-label">Seats Sold</span>
                <span class="info-value">{{ settlement.seatsSold }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Seats Remaining</span>
                <span class="info-value">{{ settlement.seatsRemainingToBeSold }}</span>
              </div>
              <div class="info-item">
                <span class="info-label">Platform Charge</span>
                <span class="info-value">{{ settlement.platformChargePercentage }}%</span>
              </div>
              <div class="info-item">
                <span class="info-label">Ready For Settlement</span>
                <span class="info-value">${{ settlement.readyForSettlement | number:'1.2-2' }}</span>
              </div>
            </div>

            <div class="financial-summary">
              <div class="financial-row">
                <span>Gross Amount</span>
                <span>${{ settlement.readyForSettlement | number:'1.2-2' }}</span>
              </div>
              <div class="financial-row deduction">
                <span>Platform Charges</span>
                <span>-${{ settlement.platformChargesAmount | number:'1.2-2' }}</span>
              </div>
              <div class="financial-row deduction">
                <span>Shipping Charges</span>
                <span>-${{ (settlement.shippingChargesAmount || 0) | number:'1.2-2' }}</span>
              </div>
              <div class="financial-row total">
                <span>Net Settlement</span>
                <span>${{ settlement.toBeSettledAmountAfterPlatformChargesDeduction | number:'1.2-2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
